import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { v4 as uuidv4 } from 'uuid';

/**
 * Uploads a file to a temporary S3 bucket.
 * @param {File} selectedFile - The file to upload
 * @param {string} fileName - fileName overload
 * @returns {Promise<{ url: string, id: string }>} The URL and ID of the uploaded file
 * @throws {Error} If the upload fails
 */
const uploadToTempS3File = (selectedFile, fileName = null) =>
  new Promise((resolve, reject) => {
    const correctFileName = fileName ?? selectedFile.name;
    const newFileName = correctFileName.split('/').pop();
    const filePath = correctFileName.split('/').slice(0, -1).join('/');
    const fileExtension = newFileName.split('.').pop();
    const correctFN = `${filePath}/${uuidv4()}.${fileExtension}`;

    const encodedFileName = correctFN;
    const params = {
      client: new S3Client({
        region: import.meta.env.VITE_REGION ?? 'eu-west-1',
        credentials: {
          accessKeyId: import.meta.env.VITE_BUCKET_ACCESS_KEY,
          secretAccessKey: import.meta.env.VITE_BUCKET_SECRET_KEY,
        },
      }),

      params: {
        Bucket: import.meta.env.VITE_BUCKET_NAME,
        Key: encodedFileName,
        Body: selectedFile,
        ContentType: selectedFile.type ?? selectedFile.fileType,
      },
      queueSize: 4, // optional concurrency configuration
      partSize: 1024 * 1024 * 5, // optional size of each part, in bytes, at least 5MB
      leavePartsOnError: false, // optional manually handle dropped parts
    };
    const upload = new Upload(params);

    upload
      .done()
      .then((data) => {
        resolve({ url: data.Key, id: data.Key });
      })
      .catch((error) => {
        reject(error);
      });
  });

export default uploadToTempS3File;
